import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { BaseToastPlate } from '../components/base-toast-plate/component.js';

var styles = {"actionSection":"toast-plate__actionSection_uy04u","title":"toast-plate__title_uy04u","closeButtonWrapper":"toast-plate__closeButtonWrapper_uy04u","closeButton":"toast-plate__closeButton_uy04u"};
require('./desktop.css')

var ToastPlateDesktop = forwardRef(function (restProps, ref) { return React.createElement(BaseToastPlate, __assign({}, restProps, { styles: styles, ref: ref })); });

export { ToastPlateDesktop };
